import axiosInstance from '~/services/api/axios';

import {ApiRoute, ConstantApiParamKey} from '$constants/api';

export async function getPricingList({
  categoryId,
  search,
  sort_by,
  sort_direction,
  per_page,
  page_no,
}: IGetPricingListParams): Promise<{
  pricingList: IPricingEntry[];
  totalPages: number;
  totalRecords: number;
}> {
  const response = await axiosInstance.get<IGetPricingListResponse>(
    ApiRoute.PricingList,
    {
      params: {
        category_id: categoryId,
        ...(search ? {search} : {}),
        ...(sort_by ? {sort_by} : {}),
        ...(sort_direction ? {sort_direction} : {}),
        ...(per_page ? {per_page} : {}),
        ...(page_no ? {page_no} : {}),
      },
    }
  );

  const {pricing_entries, total_pages, total_records} =
    response?.data?.data ?? {};

  return {
    pricingList: pricing_entries,
    totalPages: total_pages,
    totalRecords: total_records,
  };
}

export async function postCreatePricingEntry(
  payload: IPostPricingEntryPayload
): Promise<PostPricingEntryResponse> {
  const response = await axiosInstance.post<PostPricingEntryResponse>(
    ApiRoute.PricingList,
    payload
  );

  return response?.data;
}

export async function putUpdatePricingEntry({
  id,
  ...payload
}: IPutPricingEntryPayload): Promise<IPutPricingEntryResponse> {
  const response = await axiosInstance.put<IPutPricingEntryResponse>(
    `${ApiRoute.PricingList}/${id}`,
    payload
  );

  return response?.data;
}

export async function deletePricingEntry(
  id: number
): Promise<IDeletePricingEntryResponse> {
  const response = await axiosInstance.delete<IDeletePricingEntryResponse>(
    `${ApiRoute.PricingList}/${id}`
  );

  return response?.data;
}

export async function getCategoriesList(): Promise<IGetCategoriesResponse> {
  const response = await axiosInstance.get<IGetCategoriesResponse>(
    ApiRoute.Constant,
    {
      params: {
        key: ConstantApiParamKey.Category,
      },
    }
  );

  return response.data;
}
